<template>
    <v-app pb-3>
        <v-content>
            <v-container
                style="max-width: 1240px"
                class="py-4 header-part"
                v-if="!b2b"
            >
                <v-layout v-if="!isWidget">
                    <v-flex class="create-new-calc">
                        <a
                            class="policy ml-2"
                            style="text-decoration: underline"
                            @click="clearProgress"
                        >
                            Создать новый расчёт
                        </a>
                    </v-flex>
                </v-layout>

                <v-layout class="header-part-title">
                    <v-flex xs12 py-2>
                        <h2>Расчёт стоимости ОСАГО</h2>
                        <span style="font-size: 20px; margin: 5px 0"
                        >в 15 страховых компаниях</span
                        >
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container style="max-width: 1240px; padding-top: 100px;">
                <div class="breadcrumb-new">
                    <a href="/list">Страховые продукты</a>
                    <span>›</span>
                    <span>Расчет стоимости ОСАГО</span>
                </div>
                <div class="top-row">
                    <h1 class="page-title">Расчет стоимости <span>ОСАГО</span></h1>
                </div>
            </v-container>

            <v-form ref="form" v-model="valid" class="osago-form-wrapper">
                <v-container
                    style="max-width: 1240px"
                >
                    <v-layout row wrap pt-3 pb-3 v-if="showProductsTab && b2b">
                        <v-tabs
                            v-model="product"
                            :grow="true"
                            slider-color="#000"
                        >
                            <v-tab @click="" style="min-width: 160px">
                                Новый полис
                            </v-tab>
                            <v-tab @click="goToProlongation" style="min-width: 160px">
                                Пролонгация
                            </v-tab>
                        </v-tabs>
                    </v-layout>
                </v-container>

                <v-container
                    class="policy-list-table"
                    style="max-width: 1240px"
                >
                    <div>
                        <v-layout row wrap v-if="changeHistory21Vek && changeHistory21Vek.length">
                            <v-flex xs12 pb-0>
                                <h4>История изменений:</h4>
                            </v-flex>
                            <v-flex xs12>
                                <div
                                    v-for="(item, index) in changeHistory21Vek"
                                    :key="index"
                                >
                                    • {{ item }}
                                </div>
                            </v-flex>
                        </v-layout>
                    </div>

                    <v-layout>
                        <v-flex xs12 pb-2 pt-0>
                            <h2 id="tariff-change-feature">Водители</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 py-0>
                            <v-checkbox
                                v-model="unlimitedDrivers"
                                label="Количество допущеных водителей не ограничено"
                                @change="unlimitedDriversChange(unlimitedDrivers)"
                                class="mt-0"
                            />
                        </v-flex>
                    </v-layout>

                    <div
                        style="max-width: 1240px" class="py-0"
                        v-for="(driver, key) in drivers" :key="driver.n"
                        v-if="!unlimitedDrivers"
                    >
                        <v-layout>
                            <v-flex xs12 pt-4 pb-0>
                                <h3 v-if="driver.isOwner && driver.isInsurer">Водитель {{ driver.n }} (Собственник и
                                    страхователь)</h3>
                                <h3 v-if="!driver.isOwner && driver.isInsurer">Водитель {{ driver.n }} (Страхователь)</h3>
                                <h3 v-if="driver.isOwner && !driver.isInsurer">Водитель {{ driver.n }} (Собственник)</h3>
                                <h3 v-if="!driver.isOwner && !driver.isInsurer">Водитель {{ driver.n }}</h3>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex xs12 sm4 py-0>
                                <v-checkbox
                                    label="Водитель является собственником авто"
                                    v-model="driver.isOwner"
                                    @change="driverIsOwnerChange(driver)"
                                    class="pb-0"
                                />
                            </v-flex>
                            <v-flex xs12 sm4 py-0>
                                <v-checkbox
                                    label="Водитель является страхователем авто"
                                    v-model="driver.isInsurer"
                                    @change="driverIsInsurerChange(driver)"
                                    class="pb-0"
                                />
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap align-end>
                            <v-flex xs12 md6 lg4 py-0 style="align-self: flex-end">
                                <v-checkbox
                                    v-if="!isEgarant"
                                    style="margin-top: 0px; height: 25px;"
                                    v-model="driver.fio.old"
                                    :label="'Менялась фамилия после ' + yearBefore"
                                    @change="oldSurnameToggle(driver)"
                                />
                                <osago-name
                                    v-model="driver.fio.surname"
                                    label="Фамилия"
                                />
                            </v-flex>
                            <v-flex xs12 md6 lg4 py-0
                                    v-if="driver.fio.old"
                            >
                                <osago-name
                                    v-model="driver.fio.oldSurname"
                                    label="Старая фамилия"
                                />
                            </v-flex>
                            <v-flex xs12 md6 lg3 py-0>
                                <osago-name
                                    v-model="driver.fio.name"
                                    label="Имя"
                                />
                            </v-flex>
                            <v-flex xs12 md6 lg3 py-0>
                                <osago-name
                                    v-model="driver.fio.patronymic"
                                    label="Отчество"
                                    optional="true"
                                    :noField.sync="driver.fio.noPatronymic"
                                    genitiveLabel="отчества"
                                    @change="setGender(driver)"
                                />
                                <osago-gender
                                    v-if="driver.fio.noPatronymic"
                                    v-model="driver.gender"
                                    label="Пол"
                                    :noField.sync="driver.gender"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md2 lg2 py-0>
                                <osago-date
                                    v-model="driver.birthday"
                                    label="Дата рождения"
                                    isBirthday="true"
                                    :max="dateDriversMinimal"
                                    @change="driver.dateDriverPassport = getDateDriverPassport(driver);
                                        driver.dateFirstLicense = getDateFirstLicense(driver)"
                                    :isHideMobile="true"
                                />
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex class="xs12 sm6 md3 international-field" id="international-driver-license" py-0>
                                <v-checkbox
                                    style="margin-top: 0px; height: 25px;"
                                    v-model="driver.license.isInternationalDriverLicense"
                                    label="Иностранные права"
                                    @change="internationLicenseToggle(driver)"
                                />
                                <v-text-field
                                    v-if="!driver.license.isInternationalDriverLicense"
                                    value="Россия"
                                    label="Страна выдачи прав"
                                    :disabled="true"
                                />
                                <v-autocomplete
                                    v-if="driver.license.isInternationalDriverLicense"
                                    v-model="driver.license.internationalCountryCode"
                                    label="Страна выдачи прав"
                                    :items="countriesArray"
                                    item-value="value"
                                    item-text="text"
                                    :rules="[rules.required]"
                                    :loading="countriesLoading"
                                    :disabled="countriesLoading"
                                    :placeholder="countriesLoading ? 'Страны подгружаются...' : ''"
                                    @change="changeInternationalCountryName(driver)"
                                />
                            </v-flex>

                            <v-flex xs12 sm6 md3 lg3 py-0 style="align-self: flex-end">
                                <v-checkbox
                                    v-if="!isEgarant"
                                    style="margin-top: 0px; height: 25px"
                                    v-model="driver.license.old"
                                    :label="'Менял права после ' + yearBefore"
                                    @change="oldLicenseToggle(driver)"
                                    :disabled="driver.license.isInternationalDriverLicense"
                                />
                                <v-text-field
                                    v-if="!driver.license.isInternationalDriverLicense"
                                    v-model="driver.license.seriesNumber"
                                    :label="(driver.license.old ? 'Новые права' : 'Права') + ': серия и номер'"
                                    :rules="[rules.required, rules.license]"
                                    @paste="handlePasteSeriesNumber($event, driver)"
                                    :mask="driver.maskSeriesNumber"
                                    return-masked-value
                                    validate-on-blur
                                    @input="updateMaskSeriesNumber(driver.license.seriesNumber, driver)"
                                />
                                <v-text-field
                                    v-if="driver.license.isInternationalDriverLicense"
                                    v-model="driver.license.internationalSeries"
                                    :label="(driver.license.old ? 'Новые права' : 'Иностранные права') + ': серия'"
                                    :rules="[rules.base, rules.licenseSeriesLength]"
                                    validate-on-blur
                                    @keyup.native="driver.license.internationalSeries = removeSymbols(driver.license.internationalSeries)"
                                />
                            </v-flex>
                            <v-flex
                                xs12 sm6 md3 lg3 py-0 style="align-self: flex-end"
                                v-if="driver.license.isInternationalDriverLicense"
                            >
                                <v-text-field
                                    v-model="driver.license.internationalNumber"
                                    :label="(driver.license.old ? 'Новые права' : 'Иностранные права') + ': номер'"
                                    :rules="[rules.required, rules.base, rules.licenseNumberLength]"
                                    validate-on-blur
                                    @keyup.native="driver.license.internationalSeries = removeSymbols(driver.license.internationalSeries)"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3 py-0 style="align-self: flex-end"
                                    v-if="driver.license.old"
                            >
                                <v-text-field
                                    v-model="driver.license.oldSeriesNumber"
                                    label="Старые права: серия и номер"
                                    :rules="[rules.required, rules.license,noEquilSeriesNumber]"
                                    @paste="handlePasteOldSeriesNumber($event, driver)"
                                    :mask="driver.maskOldSeriesNumber"
                                    return-masked-value
                                    validate-on-blur
                                    @input="inputOldLicenseNumber($event, driver); updateMaskOldSeriesNumber(driver.license.oldSeriesNumber, driver)"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3 py-0 style="align-self: flex-end">
                                <v-checkbox
                                    style="margin-top: 0px; height: 25px"
                                    v-model="driver.license.rememberYearOnly"
                                    label="Помню только год"
                                />
                                <v-autocomplete
                                    v-if="driver.license.rememberYearOnly"
                                    :items="getFirstLicenseYears(driver.dateFirstLicense, dateToday)"
                                    :rules="[rules.required]"
                                    :value="driver.license.date ? +driver.license.date.split('-')[0] : null"
                                    @change="driver.license.date = $event + '-12-31';"
                                    label="Год выдачи первых прав"
                                />
                                <osago-date
                                    v-if="!driver.license.rememberYearOnly"
                                    v-model="driver.license.date"
                                    label="Дата выдачи первых прав"
                                    :isFirstLicense="true"
                                    :min="driver.dateFirstLicense"
                                    :max="dateToday"
                                    :restrictJan1="true"
                                    @blur="driver.dateFirstLicense = getDateFirstLicense(driver)"
                                    :isHideMobile="true"
                                />
                            </v-flex>

                            <v-flex xs12 sm4 pt-0 style="align-self: flex-end" v-if="driver.kbmText">
                                <p class="pt-3 pb-2">
                                    <span class="pt-3 driver-kbm-text">{{ driver.kbmText }}</span>
                                </p>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap pt-1 v-if="driver.isOwner || driver.isInsurer">
                            <v-flex xs12 sm6 md3 lg2 py-0>
                                <h4 style="display: inline">Паспорт</h4>

                                <v-text-field
                                    v-model="driver.passport.seriesNumber"
                                    :rules="[rules.required,rules.passport]"
                                    @blur="setPassportIssuedBy(driver)"
                                    @paste="removeSpacesOnPaste($event, driver.passport.seriesNumber)"
                                    label="Серия и номер"
                                    mask="#### ######"
                                    return-masked-value
                                    validation-on-blur
                                    required
                                    class="pt-1"
                                />
                            </v-flex>
                            <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                                <osago-date
                                    label="Дата выдачи"
                                    v-model="driver.passport.date"
                                    :passportAgeCheck="driver.dateDriverPassport"
                                    :min="driver.dateDriverPassport"
                                    :max="dateToday"
                                    :isHideMobile="true"
                                />
                            </v-flex>

                            <v-flex xs12 md12 lg8 py-0>
                                <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                                <img class="tip-icon" src="/svg/q.svg" alt=""
                                     data-tippy-animateFill="false"
                                     data-tippy-animation="scale"
                                     data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                                />

                                <osago-address-dadata
                                    :model="driver.address"
                                    :checkHouseFiasLevel="true"
                                    class="pt-1"
                                />
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex shrink pt-0 pb-0
                                    v-if="drivers.length < 6 && driver.n === drivers.length"
                                    class="driverControls"
                            >
                                <a @click="addDriver(driver)">
                                    <img src="/svg/plus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                    Добавить водителя
                                </a>
                            </v-flex>
                            <v-flex grow pt-0 pb-0
                                    v-if="drivers.length > 1"
                                    class="driverControls"
                            >
                                <a @click="removeDriver(driver)">
                                    <img src="/svg/minus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                    Убрать водителя
                                </a>
                            </v-flex>
                        </v-layout>
                    </div>

                </v-container>

                <v-container
                    class="policy-list-table"
                    style="max-width: 1240px"
                    v-if="!driverIsOwner && !unlimitedDrivers"
                >
                    <v-layout>
                        <v-flex pb-4 pt-0>
                            <h2 v-if="!driverIsInsurer">Собственник и страхователь</h2>
                            <h2 v-if="driverIsInsurer">Собственник</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name v-model="owner.fio.surname" label="Фамилия"/>
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name v-model="owner.fio.name" label="Имя"/>
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="owner.fio.patronymic"
                                label="Отчество"
                                optional="true"
                                :noField.sync="owner.fio.noPatronymic"
                                genitiveLabel="отчества"
                                @change="setGender(owner)"
                            />
                            <osago-gender
                                v-if="owner.fio.noPatronymic"
                                v-model="owner.gender"
                                label="Пол"
                                :noField.sync="owner.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="owner.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="
                  owner.dateDriverPassport = getDateDriverPassport(owner);
                  owner.dateFirstLicense = getDateFirstLicense(owner);
                "
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0>
                            <h4 style="display: inline">Паспорт</h4>

                            <v-text-field
                                v-model="owner.passport.seriesNumber"
                                :rules="[rules.required, rules.passport]"
                                @blur="setPassportIssuedBy(owner)"
                                @paste="
                  removeSpacesOnPaste($event, owner.passport.seriesNumber)
                "
                                label="Серия и номер"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                                class="pt-1"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="owner.passport.date"
                                :passportAgeCheck="owner.dateDriverPassport"
                                :min="owner.dateDriverPassport"
                                :max="dateToday"
                                :isHideMobile="true"
                            />
                        </v-flex>

                        <v-flex xs12 md12 lg8 py-0>
                            <h4 style="display: inline; margin: 5px 0 -5px">
                                Адрес регистрации
                            </h4>
                            <img
                                class="tip-icon"
                                src="/svg/q.svg"
                                alt=""
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />

                            <osago-address-dadata
                                :model="owner.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    class="policy-list-table"
                    style="max-width: 1240px"
                    v-if="driverIsOwner && !driverIsInsurer && !unlimitedDrivers"
                >
                    <v-layout>
                        <v-flex pb-4 pt-0>
                            <h2>Страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name v-model="insurer.fio.surname" label="Фамилия"/>
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name v-model="insurer.fio.name" label="Имя"/>
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="insurer.fio.patronymic"
                                label="Отчество"
                                optional="true"
                                :noField.sync="insurer.fio.noPatronymic"
                                genitiveLabel="отчества"
                                @change="setGender(insurer)"
                            />
                            <osago-gender
                                v-if="insurer.fio.noPatronymic"
                                v-model="insurer.gender"
                                label="Пол"
                                :noField.sync="insurer.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="insurer.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="
                  insurer.dateDriverPassport = getDateDriverPassport(insurer);
                  insurer.dateFirstLicense = getDateFirstLicense(insurer);
                "
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0>
                            <h4 style="display: inline">Паспорт</h4>

                            <v-text-field
                                v-model="insurer.passport.seriesNumber"
                                :rules="[rules.required, rules.passport]"
                                @blur="setPassportIssuedBy(insurer)"
                                @paste="
                  removeSpacesOnPaste($event, insurer.passport.seriesNumber)
                "
                                label="Серия и номер"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                                class="pt-1"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="insurer.passport.date"
                                :passportAgeCheck="insurer.dateDriverPassport"
                                :max="dateToday"
                                :min="insurer.dateDriverPassport"
                                :isHideMobile="true"
                            />
                        </v-flex>

                        <v-flex xs12 md12 lg8 py-0>
                            <h4 style="display: inline; margin: 5px 0 -5px">
                                Адрес регистрации
                            </h4>
                            <img
                                class="tip-icon"
                                src="/svg/q.svg"
                                alt=""
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />

                            <osago-address-dadata
                                :model="insurer.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    v-if="unlimitedDrivers"
                    class="policy-list-table"
                    style="max-width: 1240px"
                >
                    <v-layout>
                        <v-flex pb-4 pt-0>
                            <h2>Собственник и страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name v-model="owner.fio.surname" label="Фамилия"/>
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name v-model="owner.fio.name" label="Имя"/>
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="owner.fio.patronymic"
                                label="Отчество"
                                optional="true"
                                :noField.sync="owner.fio.noPatronymic"
                                genitiveLabel="отчества"
                                @change="setGender(owner)"
                            />
                            <osago-gender
                                v-if="owner.fio.noPatronymic"
                                v-model="owner.gender"
                                label="Пол"
                                :noField.sync="owner.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="owner.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="
                  owner.dateDriverPassport = getDateDriverPassport(owner);
                  owner.dateFirstLicense = getDateFirstLicense(owner);
                "
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0>
                            <h4 style="display: inline">Паспорт</h4>

                            <v-text-field
                                v-model="owner.passport.seriesNumber"
                                :rules="[rules.required, rules.passport]"
                                @blur="setPassportIssuedBy(owner)"
                                @paste="
                  removeSpacesOnPaste($event, owner.passport.seriesNumber)
                "
                                label="Серия и номер"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                                class="pt-1"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="owner.passport.date"
                                :passportAgeCheck="owner.dateDriverPassport"
                                :min="owner.dateDriverPassport"
                                :max="dateToday"
                                :isHideMobile="true"
                            />
                        </v-flex>

                        <v-flex xs12 md12 lg8 py-0>
                            <h4 style="display: inline; margin: 5px 0 -5px">
                                Адрес регистрации
                            </h4>
                            <img
                                class="tip-icon"
                                src="/svg/q.svg"
                                alt=""
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />

                            <osago-address-dadata
                                :model="owner.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    class="pb-0 policy-list-table"
                    style="max-width: 1240px"
                >
                    <osago-transport
                        v-model="transport"
                        :dateToday="dateToday"
                        :b2b="b2b"
                        :prevPolicyNumber="prevPolicyNumber"
                        :dateStart="dateStart"
                        :showLicensePlateInfoLoader="b2b"
                        :defaultValue="transportDefault"
                        :isEgarant="isEgarant"
                        :useType="
              useType
                ? useType
                : usagePurpose === 'personal'
                  ? USE_TYPE_PERSONAL
                  : null
            "
                        :dateOldPolis="dateOldPolis"
                        :isDraft="isDraft"
                        @numberInfoLoaded="loadRsaPolicyData"
                        @clearTransport="clearTransportAndPolicy"
                    />
                </v-container>

                <v-container
                    class="policy-list-table pb-0"
                    style="max-width: 1240px"
                >
                    <osago-insurance-conditions
                        :isEgarant="isEgarant"
                        :usagePurposes="usagePurposes"
                        :usagePurpose="usagePurpose"
                        :useTypes="useTypes"
                        :useType="useType"
                        :dateStart="dateStart"
                        :dateMin="isEgarant ? dateStartMinEgarant : dateToday"
                        :dateStartMax="dateStartMax"
                        :rules="rules"
                        :term="term"
                        :dateOldPolis="dateOldPolis"
                        :osagoCompanyName="osagoCompanyName"
                        :rsaInfoLoading="rsaInfoLoading"
                        :alertText="alertText"
                        :alertColor="alertColor"
                        @changeInsuranceConditionsData="changeInsuranceConditionsData"
                        @changeTextAndColor="changeTextAndColor"
                    />

                    <v-layout v-if="!isEgarant && b2b"
                              pt-0 pb-0 row wrap>
                        <v-flex xs12 md4 pt-0 py-0>
                            <v-text-field
                                v-model="prevPolicyNumber"
                                label="Серия и номер предыдущего полиса (если есть)"
                                :rules="[rules.policyNumber]"
                                mask="SSS ##########"
                                return-masked-value
                                validation-on-blur
                                :disabled="prevPolicyLoading"
                            />
                        </v-flex>
                        <v-flex xs12 md8 pt-2 v-if="hintText">
              <span
                  class="prev-policy-label"
                  :class="{
                  activePolice: hintTextActivity,
                  notActivePolice: !hintTextActivity,
                }"
              >
                {{ hintText }}
              </span>
                        </v-flex>
                        <v-flex xs12 md8 pt-2 v-else-if="b2b">
              <span class="prev-policy-label">
                Заполните серию и номер предыдущего полиса для увеличения шансов
                успешного оформления.<br/>Чтобы получить дополнительное
                вознаграждение дата начала нового полиса должна быть следующим
                днем после даты окончания текущего полиса.
              </span>
                        </v-flex>
                        <v-flex xs12 md8 pt-2 v-else>
              <span class="prev-policy-label">
                Заполните серию и номер предыдущего полиса для увеличения шансов
                успешного оформления.<br/>
                Дата начала нового полиса должна быть следующим днем после даты
                окончания текущего полиса.<br/>
                Выберите нужную дату в начале анкеты.
              </span>
                        </v-flex>

                        <v-checkbox
                            v-model="noDiscountForTransfer"
                            label="Посчитать без скидки за переход"
                            class="mt-0 px-2"
                        />
                    </v-layout>
                </v-container>

                <v-container
                    class="policy-list-table pb-0"
                    style="max-width: 1240px"
                >
                    <osago-user v-model="user" :b2c="!b2b" :useTempPhone="isEgarant"/>
                </v-container>

                <v-container
                    style="max-width: 1240px"
                >
                    <v-layout v-if="!isEgarant || orderStatus === 'new'" pt-4 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="validate"
                                   :loading="waitLoading"
                                   :disabled="orderStatus === 'success'"
                                   class="submit-button block to-counting">
                                {{ orderStatus === 'success' ? 'Полис оформлен' : 'Рассчитать окончательную стоимость' }}
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <div v-if="b2b" class="policy-wrapper" style="height: 100px;">
                                Отправляя анкету, соглашаюсь
                                <br/>с
                                <a
                                    class="policy"
                                    target="_blank"
                                    href="https://getpolis.ru/osago_policy"
                                >политикой обработки персональных данных</a
                                >
                                <br/>и даю
                                <a
                                    class="policy"
                                    target="_blank"
                                    href="https://getpolis.ru/soglasie_pdn"
                                >
                                    Согласие на обработку персональных данных
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="isEgarant && orderStatus !== 'new'" pt-4 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn
                                :href="'/order/' + uuid + '/draft'"
                                class="submit-button block"
                            >
                                Использовать как черновик
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>

        <transition name="fade" v-if="b2b">
            <v-container
                bg
                fill-height
                grid-list-md
                text-xs-center
                style="width: 100%"
                v-show="preloading"
                class="preloading"
            >
                <v-layout row wrap align-center>
                    <v-flex>
                        <div class="preloader-circle"></div>
                        <h2>Загрузка</h2>
                        <br/>
                        Обычно это занимает не больше 30 секунд.<br/>
                        Ждем ответы от страховых компаний.
                    </v-flex>
                </v-layout>
            </v-container>
        </transition>

        <!--    Е-Гарант    -->
        <v-container v-if="isEgarant" grid-list-lg style="max-width: 1260px" pb-0>
            <v-layout class="pt-0">
                <v-flex xs12>
                    <h2 class="pb-4">Оформить страховой полис</h2>
                    <span class="kbm-text" v-if="egarantKbmsText">{{
                            egarantKbmsText
                        }}</span>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-space-between row wrap py-0 class="result">
                <v-flex xs6 sm4 md3 pt4>
                    <img
                        v-if="egarantCompanyImg"
                        :src="egarantCompanyImg"
                        class="logo hidden-xs-only"
                    />
                    <img
                        v-if="egarantCompanyImg"
                        :src="egarantCompanyImg"
                        class="logo-sm hidden-sm-and-up"
                    />
                    <span hidden>{{ egarantLink.name }}</span>
                </v-flex>
                <v-flex>
                    <v-layout v-if="precalc.coefficients" row wrap>
                        <v-flex v-if="precalc.coefficients.tb" text-xs-center>
                            Базовая ставка
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.tb }}
              </span>
                        </v-flex>
                        <v-flex v-if="precalc.coefficients.kt" text-xs-center>
                            КТ
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.kt }}
              </span>
                        </v-flex>
                        <v-flex v-if="precalc.coefficients.kbm" text-xs-center>
                            КБМ
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.kbm }}
              </span>
                        </v-flex>
                        <v-flex v-if="precalc.coefficients.kvs" text-xs-center>
                            КВС
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.kvs }}
              </span>
                        </v-flex>
                        <v-flex v-if="precalc.coefficients.ko" text-xs-center>
                            КО
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.ko }}
              </span>
                        </v-flex>
                        <v-flex v-if="precalc.coefficients.ks" text-xs-center>
                            КС
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.ks }}
              </span>
                        </v-flex>
                        <v-flex v-if="precalc.coefficients.km" text-xs-center>
                            КМ
                            <br/>
                            <span class="data-param">
                {{ precalc.coefficients.km }}
              </span>
                        </v-flex>
                        <v-flex
                            v-if="
                precalc.premium &&
                (egarantLink.status !== 'on' ||
                  !egarantLink.created_at ||
                  egarantLink.timed_out)
              "
                            text-xs-center
                        >
                            Цена
                            <br/>
                            <span class="data-param">
                {{ precalc.premium }}
              </span>
                        </v-flex>
                        <v-flex
                            v-if="
                orderStatus !== 'success' &&
                egarantLink.status === 'on' &&
                egarantLink.created_at &&
                !egarantLink.timed_out
              "
                            text-xs-center
                        >
                            Ссылка активна
                            <br/>
                            <span
                                :class="[
                  'data-param',
                  egarantLink.time_warning ? 'warning-color' : '',
                ]"
                            >
                {{ egarantLink.time_left }}
              </span>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <template v-if="orderStatus !== 'success'">
                    <template v-if="egarantLoading">
                        <v-flex xs1>
                            <v-progress-circular indeterminate color="#00ba57">
                            </v-progress-circular>
                        </v-flex>
                    </template>
                    <template v-if="!egarantLoading">
                        <v-flex xs12 sm6 md3 v-if="!egarantLink.errors">
                            <v-layout align-center row wrap>
                                <v-flex xs12>
                                    <a
                                        v-if="egarantLink.status === 'on' && !egarantLink.timed_out"
                                        class="policy underline above-button text-center"
                                        v-clipboard="egarantLink.link"
                                        onclick="
                      PNotify.success('Ссылка скопирована в буфер обмена')
                    "
                                    >
                                        Копировать ссылку
                                    </a>
                                    <v-btn
                                        v-if="egarantLink.status === 'on' && !egarantLink.timed_out"
                                        class="submit-button egarant-button"
                                        style="display: block"
                                        :href="egarantLink.link"
                                        target="_blank"
                                    >
                                        {{
                                            precalc.premium
                                                ? "Оформить за " + precalc.premium + " ₽"
                                                : "Оформить"
                                        }}
                                    </v-btn>
                                    <a
                                        v-if="egarantLink.status === 'on' && !egarantLink.timed_out"
                                        class="policy underline mt-2 text-center"
                                        style="display: block"
                                        @click="egarantGet"
                                    >
                                        Обновить ссылку
                                    </a>
                                    <label v-if="egarantLink.status !== 'on' && !precalc.premium">
                                        Рассчитайте стоимость, чтобы получить ссылку на сервис
                                    </label>
                                    <v-btn
                                        v-if="
                      (egarantLink.status !== 'on' && precalc.premium) ||
                      (egarantLink.status === 'on' && egarantLink.timed_out)
                    "
                                        class="submit-button egarant-button"
                                        style="display: block"
                                        @click="egarantGet"
                                    >
                                        Получить ссылку
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1 v-if="egarantLink.errors">
                            <img
                                class="tip-icon"
                                src="/svg/q_red.svg"
                                alt=""
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-theme="red"
                                :data-tippy-content="egarantLink.errors"
                            />
                        </v-flex>
                    </template>
                </template>
                <template v-if="orderStatus === 'success'">
                    <v-flex xs12 sm6 md3>
                        <v-layout align-center row wrap>
                            <v-btn
                                class="submit-button egarant-button"
                                style="display: block"
                            >
                                Полис оформлен
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>

        <!--    Список расчетов    -->
        <companies-list
            id="companiesList"
            v-if="!isEgarant"
            :companiesList="companiesList"
            :b2b="b2b"
            :defaultCompany="defaultCompany"
            :allowApproveMetrika="allowApproveMetrika"
            :coefficients="precalc.coefficients"
            :dateStart="dateStart"
            :formIsChanged="formIsChanged"
            :orderStatus="orderStatus"
            :successProcessing="successProcessing"
            :newDesign="newDesign"
            :showAlertWithoutDiscount="showAlertWithoutDiscount"
            :waitFetchCross="waitFetchCross"
            :uuid="uuid"
            @handleDriversKbms="handleDriversKbms"
        />

        <transition name="fade">
            <osago-preview
                v-if="preview.show"
                :preparedFormData="preparedFormData"
                :previewUsagePurpose="usagePurposes[preparedFormData.usagePurpose]"
                :return="this.returnToEdit"
                :submit="isEgarant ? this.submitEgarant : this.submit"
                :b2b="b2b"
                :loading="wait"
            />
        </transition>

        <osago-preloader
            v-show="preloading && !b2b"
            :preloading="preloading"
            :step="5"
            :resultPreloading="resultPreloading"
            :slideInterval="4000"
            @stopPreloading="stopPreloading"
        />
    </v-app>
</template>

<script>
import _ from "lodash";
import ymMixin from "../mixins/ym";
import helperMixin from "../mixins/helper";
import moment from "moment";

export default {
    props: ['params', 'isWidget', 'authUser'],
    mixins: [ymMixin, helperMixin],

    data: () => ({
        // FormData
        term: 12,
        // useTargetPersonal: false,
        usagePurposes: null,
        // выбранная цель использования
        usagePurpose: null,
        //
        noDiscountForTransfer: false,
        privacyPolicyApproved: false,
        unlimitedDrivers: false,
        prevPolicyNumber: "",
        yearBefore: moment().subtract(1, "years").format("DD.MM.YYYY"),
        prevPolicyLoading: false,
        useType: null,
        useTypes: [],

        // данные для оформления через куратора
        defaultCompany: {
            period: null,
            premium: null,
            commission: null,
            commissionRub: null,
            kbm: null,
            is_pull: false,
        },

        drivers: [],
        owner: {
            fio: {
                surname: null,
                name: null,
                patronymic: null,
                noPatronymic: false,
                old: false,
                oldSurname: null,
            },
            gender: null,
            birthday: null,
            passport: {
                seriesNumber: null,
                date: null,
                issuedBy: null,
                isInternationalDriverLicense: false,
            },
            address: {
                search: null,
                /* region": "Ростовская обл",
                        city": "г Ростов-на-Дону",
                        street": "ул Обороны",
                        house": "д 1",
                        flat": "11",
                        cityKladr": "6100000100000",
                        streetKladr": "61000001000111600",
                        postalCode": "344082" */
            },
            passportDate: null,
        },
        insurer: {
            fio: {
                surname: null,
                name: null,
                patronymic: null,
                noPatronymic: false,
                old: false,
                oldSurname: null,
            },
            gender: null,
            birthday: null,
            passport: {
                seriesNumber: null,
                date: null,
                issuedBy: null,
                isInternationalDriverLicense: false,
            },
            address: {
                search: null,
            },
            passportDate: null,
        },
        transportDefault: null,
        transport: {
            category: null, //'B',
            categoryGibdd: null, //'B',
            mark: null,
            model: null,
            modelGibdd: null,
            writtenMark: null,
            writtenModel: null,
            idType: "vin",
            vin: null,
            bodyNumber: null,
            chassisNumber: null,
            power: null,
            licensePlate: null,
            noLicensePlate: false,
            yearIssue: null,
            carCode: null,
            loadingLicensePlateInfo: null,
            powerAvtocod: null,
            powerGibdd: null,
            carDoc: {
                type: "pts",
                seriesNumber: null,
                date: null,
            },
            toDoc: {
                type: "dcard",
                seriesNumber: null,
                endDate: null,
            },
            gibddData: {
                category: null,
                model: null,
                powerHp: null,
                vin: null,
            },
        },
        toDocDefault: {
            type: "dcard",
            seriesNumber: null,
            endDate: null,
        },
        user: {
            phone: "7",
            email: null,
            phoneCode: null,
            useTempNumber: false,
            tempPhone: null,
        },
        // FormData end
        uuid: null,
        b2b: false,
        orderStatus: "new",
        valid: true,
        product: 0,
        showProductsTab: true,
        isEgarant: false,
        egarantLoading: false,
        egarantNeedToCheckCalculation: false,
        egarantCheckInterval: null,
        egarantCompanyImg: null,
        egarantLinkInterval: null,
        egarantLink: {
            alias: "",
            name: "",
            draftId: null,
            errors: null,
            link: null,
            status: "off",
            loading: false,
            created_at: null,
            time_left: null,
            timed_out: false,
            time_warning: false,
            kbms: null,
        },
        egarantLinkDefault: {
            alias: "",
            name: "",
            draftId: null,
            errors: null,
            link: null,
            status: "off",
            loading: false,
            created_at: null,
            time_left: null,
            timed_out: false,
            time_warning: false,
            kbms: null,
        },

        precalc: {
            premium: null,
            coefficients: null,
        },

        dateToday: "",
        dateTomorrow: "",
        dateStartMax: "",
        dateStartMinEgarant: "",
        dateFrom: "",
        dateStart: "",
        getpolisPhone: "",

        preloading: false,
        preview: {
            show: false,
        },
        processings: 0,
        companiesList: [],
        dateDriversMinimal: "",

        lastSavedFormData: null,
        preparedFormData: null,
        autoSaveInterval: null,
        autoGetCodeInterval: null,

        wait: false,

        b2c: false,
        autoRequest: false,
        resultPreloading: false,
        rsaInfoLoading: false,
        osagoCompanyName: null,
        dateOldPolis: null,
        noEquilSeriesNumber: true,
        allowApproveMetrika: false,

        alertText: null,
        alertColor: null,

        hintText: null,
        hintTextActivity: false,

        rsaInfo: {
            active: false,
            companyName: null,
            createDate: null,
            endDate: null,
            startDate: null,
            insurant: null,
            insurantBirthday: null,
            policyNumber: null,
            policySerial: null,
            isActivePeriod: false,
            kbm: null,
            regNumber: null,
            power: null,
            purposePersonal: false,
            ownerBirthday: null,
            normalizeCompanyName: null,
            systemCompanyAlias: null,
        },

        isDraft: null,
        tsChanged: null,

        rules: {
            required: (v) => !!v || "Обязательное поле",
            useTarget: (v) => v || "Необходимо подтвердить цель использования авто",
            approvePrivacyPolicy: (v) =>
                v || "Необходимо согласиться с политикой обработки персональных данных",
            license: (v) =>
                /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) ||
                /^[A-Za-zА-Яа-яЁё]{2} \d{6}$/.test(v) ||
                "Неверный формат",
            passport: (v) => /^\d{4} \d{6}$/.test(v) || "Неверный формат",
            policyNumber: (v) =>
                v === "" || /^[А-ЯA-Z]{3} \d{10}$/.test(v) || "Неверный формат",
            base: (v) =>
                /^[\dA-Za-zА-Яа-яЁё\- /.]*$/.test(v) || "Неверный формат",
            internationalLicense: (v) =>
                /^[A-Za-z0-9]{1,40}$/.test(v) ||
                "Только латиница и цифры, от 1 до 40 символов",
            licenseSeriesLength: (v) => {
                if (!v) return true;
                return (
                    (v.length >= 2 && v.length <= 4) ||
                    "Недопустимое количество символов"
                );
            },
            licenseNumberLength: (v) => {
                if (!v) return true;
                return (
                    (v.length >= 4 && v.length <= 14) ||
                    "Недопустимое количество символов"
                );
            },
        },
        formIsChanged: false,
        successProcessing: {
            companyId: null,
            premium: null,
        },
        cross: {
            show: false,
        },
        newDesign: true,
        showAlertWithoutDiscount: false,

        // Для обратного отсчета по кнопке "Рассчитать окончательную стоимость"
        waitLoading: false,
        remainingTime: 60,
        isOrderDataLoaded: false,
        waitFetchCross: false,
        kbms: null,
        crossOffers: [],
        crossRequested: false,
        // Приоритетная пролонгация
        priorityProlongationAlias: null,
        priorityProlongationSegmentType: null,
        excludedProlongationAliasesByType: {},
        excludedProlongationAliases: [],
        priorityProlongationSessionActive: false,
        priorityProlongationResolved: false,
        priorityProlongationApproved: false,
        changeHistory21Vek: null,
        countriesLoading: false,
        countriesArray: [],
        isAnyInternationalRight: false,
        rsaStatusResolved: false,
        rsaInfoRequestPromise: null,
    }),

    created: async function () {
        this.USE_TYPE_PERSONAL = Vue.GetpolisConstants.USE_TYPES.PERSONAL;
        this.transportDefault = _.cloneDeep(this.transport);
        const params = JSON.parse(window.atob(this.params));
        this.uuid = params.uuid;

        this.KBM_COMPANIES_LIST = ["tinkoff", "renessans"];
        this.WAIT_PREV_POLICY_COMPANIES_LIST = ["absolute", "sk-21-vek", "maks"];

        if (params.isEgarant) {
            this.isEgarant = true;
        }
        this.loadConfig(params.config);
        if (params.site === "B2B") {
            this.b2b = true;
        }
        if (params.orderStatus) {
            this.orderStatus = params.orderStatus;
        }
        if (params.orderData) {
            this.loadOrderData(params.orderData);
            this.showProductsTab = false;
        }
        if (!params.orderData) {
            this.addDriver();
            this.drivers[0].isOwner = true;
            this.drivers[0].isInsurer = true;

            if (this.authUser && (this.authUser.email || this.authUser.phone)) {
                this.user.email = this.authUser.email ? this.authUser.email : '';
                this.user.phone = this.authUser.phone ? this.authUser.phone.replace(/\D/g, '') : '';
            }
        }
        if (params.companiesList) {
            this.companiesList = params.companiesList;
        }
        if (params.usagePurposes) {
            this.usagePurposes = params.usagePurposes;
        }
        if (params.useTypes) {
            Vue.set(this, "useTypes", params.useTypes);
        }
        if (params.changeHistory) {
            this.changeHistory21Vek = params.changeHistory;
        }

        if (this.b2b && params.precalc) {
            const precalc = params.precalc;
            this.precalc.premium = precalc.premium;
            Vue.set(this.precalc, "coefficients", JSON.parse(precalc.coefficients));
        }

        if (this.isEgarant) {
            this.showProductsTab = false;
            this.egarantLoading = this.egarantNeedToCheckCalculation =
                !!params.egarantCalculating;
            if (this.egarantNeedToCheckCalculation) {
                this.egarantCheckIntervalOn(7000);
            }

            if (params.egarantLink) {
                const link = params.egarantLink;
                this.egarantLink.alias = link.alias;
                this.egarantLink.name = link.name;
                this.egarantLink.draftId = link.draftId;
                this.egarantLink.errors = link.errors;
                this.egarantLink.status = link.status;
                this.egarantLink.link = link.link;
                this.egarantLink.kbms = link.drivers_kbms;
                this.egarantLink.created_at = link.created_at;

                // обработка истечения срока действия ссылки Е-Гарант
                this.setEgarantTimer(link);
                // Запрос кода с временного телефона, если требуется
                if (
                    this.egarantLink.status === "on" &&
                    this.user.useTempNumber &&
                    !this.user.phoneCode
                ) {
                    this.autoGetCodeOn();
                }
            }

            if (params.egarantCompanyImg) {
                this.egarantCompanyImg = params.egarantCompanyImg;
            }
        }

        if (params.defaultCompany) {
            const comp = params.defaultCompany;
            this.defaultCompany.period = comp.period;
            this.defaultCompany.kbm = comp.kbm;
            this.defaultCompany.commission = comp.commission;
            this.defaultCompany.commissionRub = comp.commissionRub;
            this.defaultCompany.premium = comp.premium;
            this.defaultCompany.isPull = comp.is_pull;
        }

        if (!this.b2b) {
            sessionStorage.maxStep = 5;
        }

        let uri = window.location.search.substring(1);
        let urlParams = new URLSearchParams(uri);
        if (urlParams.get("autoRequest")) {
            this.autoRequest = urlParams.get("autoRequest");
            if (this.autoRequest) {
                this.validateAndSubmit();
            }
        }

        if (params.successProcessing) {
            this.successProcessing.companyId = parseInt(
                params.successProcessing.company_id,
            );
            this.successProcessing.premium = parseFloat(
                params.successProcessing.premium,
            );
        }

        this.syncPriorityProlongation(params.priorityProlongation || null);

        /*this.debouncedSetKBM = _.debounce(this.setKBM, 2000);*/
        this.debouncedLoadRSA = _.debounce(this.loadRsaPolicyData, 2000);
        await this.getRSAStatus();

        this.autoSaveOn(5000);

        if (this.isAnyInternationalRight && !this.countriesArray.length) {
            await this.fetchCountries();
        }

        setTimeout(() => {
            this.isOrderDataLoaded = true;
        }, 7000);
    },

    mounted() {
        if (!localStorage.getItem('internationalHintShown')) {
            this.showInternationalHint();
            localStorage.setItem('internationalHintShown', '1');
        }
    },

    updated: function () {
        window.tippy.default(".tip-icon");
    },

    computed: {
        driverIsOwner() {
            return _.findIndex(this.drivers, (driver) => driver.isOwner) !== -1;
        },

        driverIsInsurer() {
            return _.findIndex(this.drivers, (driver) => driver.isInsurer) !== -1;
        },

        /*kbms() {
                let kbms = null;
                if (this.isEgarant) {
                    if (this.egarantLink.kbms) {
                        kbms = JSON.parse(this.egarantLink.kbms);
                    }
                } else {
                    _.forEach(this.companiesList, function (company) {
                        if (company.kbms) {
                            kbms = JSON.parse(company.kbms);
                        }
                    });
                }
                return kbms;
            },*/

        egarantKbmsText() {
            if (this.isEgarant && this.kbms) {
                let result = "";
                for (let i = 0; i < this.kbms.length; i++) {
                    result +=
                        this.kbms[i].name +
                        " КБМ — " +
                        this.kbms[i].kbm +
                        " " +
                        this.kbms[i].kbmText;
                    if (i + 1 < this.kbms.length) {
                        result += ", ";
                    }
                }
                return result;
            }
            return null;
        },
    },

    watch: {
        kbms(value) {
            if (!value) {
                return;
            }

            let that = this;
            _.forEach(value, function (kbm) {
                _.forEach(that.drivers, function (driver) {
                    if (
                        driver.fio &&
                        driver.fio.name &&
                        kbm.first_name &&
                        driver.fio.name.toLowerCase().trim() ===
                        kbm.first_name.toLowerCase().trim() &&
                        driver.fio.surname &&
                        kbm.last_name &&
                        driver.fio.surname.toLowerCase().trim() ===
                        kbm.last_name.toLowerCase().trim() &&
                        driver.fio.patronymic &&
                        kbm.middle_name &&
                        driver.fio.patronymic.toLowerCase().trim() ===
                        kbm.middle_name.toLowerCase().trim() &&
                        driver.birthday === kbm.birth_date
                    ) {
                        driver.kbmText = "КБМ — " + kbm.kbm;
                        return false;
                    }
                });
            });
        },
        /*drivers: {
                handler() {
                    let that = this;
                    this.debouncedSetKBM();
                    _.forEach(this.drivers, function (driver) {
                        if (driver.kbmText) {
                            if ((driver.kbmText.match(/\d+\.\d+/)[0]) === '1.17') {
                                that.showAlertWithoutDiscount = true;
                                return;
                            }
                            that.showAlertWithoutDiscount = false;
                        }
                    })
                },
                deep: true
            },*/
        "transport.vin": {
            handler() {
                this.debouncedLoadRSA();
            },
            deep: true,
        },
        formIsChanged(value) {
            if (value) {
                this.waitLoading = false;
                this.remainingTime = 60;
            }
        },
        drivers: {
            deep: true,
            handler(drivers) {
                this.isAnyInternationalRight = drivers.some(
                    driver => driver.license && driver.license.isInternationalDriverLicense,
                );
            }
        }
    },

    methods: {
        checkParams() {
            const params = JSON.parse(window.atob(this.params));
        },
        inputOldLicenseNumber(event, driver) {
            if (event === driver.license.seriesNumber) {
                this.noEquilSeriesNumber = "Не может совпадать с номером новых прав";
            } else {
                this.noEquilSeriesNumber = true;
            }
        },

        clearProgress() {
            sessionStorage.removeItem("preparedFormDataStorage");
            sessionStorage.removeItem("stepFlags");
            sessionStorage.uuid = null;
            sessionStorage.step = 0;
            sessionStorage.addedDriversToStep3 = false;
            sessionStorage.maxStep = 0;
            window.location.replace("/calc/");
        },

        savePreparedData() {
            if (!this.b2b) {
                const parsed = JSON.stringify(this.preparedFormData);
                sessionStorage.setItem("preparedFormDataStorage", parsed);
            }
        },

        setPreloading() {
            if (this.b2b) {
                return;
            }
            this.resultPreloading = true;
            this.startPreloading();
        },

        startPreloading() {
            this.preloading = true;
            this.delay(27000).then(() => {
                if (this.preloading) {
                    this.preloading = false;
                    this.resultPreloading = false;
                }
            });
        },

        stopPreloading() {
            this.preloading = false;
            this.resultPreloading = false;
        },

        delay(ms) {
            return new Promise((resolve, reject) => {
                this.timeout = setTimeout(resolve, ms);
            });
        },

        setDriverBirthday(driver) {
            if (driver.birthday) {
                const [year, month, day] = driver.birthday.split("-");
                const dateFirstLicense = `${parseInt(year) + 18}-${month}-${day}`;
                const dateDriverPassport = `${parseInt(year) + 14}-${month}-${day}`;
                if (driver.license && driver.license.date) {
                    if (driver.license.date > this.dateToday) {
                        driver.license.date = this.dateToday;
                    } else if (driver.license.date < dateFirstLicense) {
                        driver.license.date = dateFirstLicense;
                    }
                }
                return {
                    dateFirstLicense: dateFirstLicense,
                    dateDriverPassport: dateDriverPassport,
                };
            }
        },

        getDateDriverPassport(driver) {
            let dates = this.setDriverBirthday(driver);
            return dates ? dates.dateDriverPassport : this.dateDriversMinimal;
        },

        getDateFirstLicense(driver) {
            let dates = this.setDriverBirthday(driver);
            return dates ? dates.dateFirstLicense : this.dateDriversMinimal;
        },

        addDriver() {
            this.drivers.push({
                n: this.drivers.length + 1,
                maskSeriesNumber: "S",
                maskOldSeriesNumber: "S",
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false,
                    old: false,
                    oldSurname: null,
                },
                license: {
                    seriesNumber: null,
                    date: null,
                    old: false,
                    oldSeriesNumber: null,
                    rememberYearOnly: false,
                    isInternationalDriverLicense: false,
                    internationalCountryCode: '643',
                    internationalCountryName: 'Россия',
                    internationalSeries: '',
                    internationalNumber: '',
                },
                passport: {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null,
                    isInternationalDriverLicense: false,
                },
                address: {
                    search: null,
                },
                birthday: null,
                gender: null,
            });
        },

        removeDriver(driver) {
            this.$delete(this.drivers, driver.n - 1);

            this.drivers = this.drivers.map(function (drv, index) {
                drv.n = index + 1;
                return drv;
            });
        },

        oldLicenseToggle(driver) {
            driver.license.oldSeriesNumber = "";
            if (!driver.license.old && driver.fio.old) {
                driver.fio.old = false;
                driver.fio.oldSurname = "";
            }
            this.drivers = this.drivers.map((item) =>
                item.n === driver.n ? driver : item,
            );
        },

        async internationLicenseToggle(driver) {
            driver.license.seriesNumber = '';
            driver.license.internationalSeries = '';
            driver.license.internationalNumber = '';

            if (!driver.license.isInternationalDriverLicense) {
                driver.license.internationalCountryCode = '643';
                driver.license.internationalCountryName = 'Россия';
            }

            if (driver.license.isInternationalDriverLicense) {
                driver.license.internationalCountryCode = null;
                driver.license.internationalCountryName = null;
                driver.license.internationalSeries = '';
                driver.license.internationalNumber = '';
                driver.license.old = false;
            }

            if (driver.license.isInternationalDriverLicense && !this.countriesArray.length) {
                await this.fetchCountries();
            }

            driver.passport.isInternationalDriverLicense = driver.license.isInternationalDriverLicense;
        },

        oldSurnameToggle(driver) {
            driver.fio.oldSurname = "";
            if (driver.fio.old && !driver.license.old) {
                driver.license.old = true;
                driver.license.oldSeriesNumber = "";
            }
            this.drivers = this.drivers.map((item) =>
                item.n === driver.n ? driver : item,
            );
        },

        isSamePerson(person1, person2) {
            if (
                !person1.birthday ||
                !person2.birthday ||
                !person1.fio.surname ||
                !person2.fio.surname ||
                !person1.fio.name ||
                !person2.fio.name
            )
                return false;
            return (
                person1.birthday === person2.birthday &&
                _.isEqual(person1.fio, person2.fio)
            );
        },

        setGender(person) {
            if (person.fio.patronymic) {
                person.gender = person.fio.patronymic.endsWith("а")
                    ? "Женский"
                    : "Мужской";
            }
        },

        setPassportIssuedBy(person) {
            if (person.passport.seriesNumber) {
                person.passport.issuedBy = "МВД РФ";
            }
        },

        clearPassportAndAddress(person) {
            person.passport = {
                seriesNumber: null,
                date: null,
                issuedBy: null,
                isInternationalDriverLicense: false,
            };
            person.address = {
                search: null,
            };
        },

        clearFioAndBirthday(person) {
            person.fio = {
                surname: null,
                name: null,
                patronymic: null,
                noPatronymic: false,
                old: false,
                oldSurname: null,
            };
            person.birthday = null;
        },

        clearPerson(person) {
            this.clearFioAndBirthday(person);
            this.clearPassportAndAddress(person);
        },

        clearTransportAndPolicy() {
            this.clearTransport();
            this.clearPrevPolicy();
        },

        clearTransport() {
            this.transport = _.cloneDeep(this.transportDefault);
        },

        clearPrevPolicy() {
            this.prevPolicyNumber = "";
        },

        unlimitedDriversChange(val) {
            if (val) {
                let that = this;
                this.drivers = this.drivers.map((driver) => {
                    if (driver.isOwner) {
                        that.owner = driver;
                    }
                    return driver;
                });
            } else {
                if (this.drivers === "unlimited") {
                    let driver = _.cloneDeep(this.owner);
                    driver.license = {
                        seriesNumber: null,
                        date: null,
                        old: false,
                        oldSeriesNumber: null,
                        rememberYearOnly: false,
                        isInternationalDriverLicense: false,
                        internationalCountryCode: '643',
                        internationalCountryName: 'Россия',
                        internationalSeries: '',
                        internationalNumber: '',
                    };
                    driver.n = 1;
                    driver.isOwner = driver.isInsurer = true;
                    this.drivers = [driver];
                }
            }
        },

        driverIsOwnerChange(val) {
            this.drivers = this.drivers.map((driver) => {
                if (driver.n !== val.n) {
                    driver.isOwner = false;
                }
                return driver;
            });

            if (!val.isInsurer) {
                this.clearPassportAndAddress(val);
            }

            this.clearPerson(this.owner);
        },

        driverIsInsurerChange(val) {
            this.drivers = this.drivers.map((driver) => {
                if (driver.n !== val.n) {
                    driver.isInsurer = false;
                }
                return driver;
            });

            if (!val.isOwner) {
                this.clearPassportAndAddress(val);
            }

            this.clearPerson(this.insurer);
        },

        loadConfig(config) {
            this.getpolisPhone = config.getpolis_phone;
            this.dateToday = config.todayDate;
            this.dateTomorrow = config.tomorrowDate;
            this.dateStartMax = config.dateStartMax;
            this.dateStartMinEgarant = moment(this.dateToday)
                .add(4, "days")
                .format("YYYY-MM-DD");
            this.dateFrom = config.offsetDate;
            this.dateDriversMinimal = config.driversMinimalDate;
        },

        loadOrderData(data) {
            // Для старых записей, где отсутствует search, заполняем его
            if (data.owner.address !== undefined) {
                if (data.owner.address.search === undefined) {
                    data.owner.address.search =
                        data.owner.address.region +
                        (data.owner.address.city ? ", " + data.owner.address.city : "") +
                        (data.owner.address.street
                            ? ", " + data.owner.address.street
                            : "") +
                        (data.owner.address.house ? ", " + data.owner.address.house : "") +
                        (data.owner.address.flat ? ", кв " + data.owner.address.flat : "");
                }
                if (data.owner.fio.noPatronymic === undefined) {
                    data.owner.fio.noPatronymic = false;
                }
            }
            if (data.insurer !== undefined) {
                if (
                    data.insurer.address !== undefined &&
                    data.insurer.address.search === undefined
                ) {
                    data.insurer.address.search =
                        data.insurer.address.region +
                        (data.insurer.address.city
                            ? ", " + data.insurer.address.city
                            : "") +
                        (data.insurer.address.street
                            ? ", " + data.insurer.address.street
                            : "") +
                        (data.insurer.address.house
                            ? ", " + data.insurer.address.house
                            : "") +
                        (data.insurer.address.flat
                            ? ", кв " + data.insurer.address.flat
                            : "");
                }
                if (data.insurer.fio.noPatronymic === undefined) {
                    data.insurer.fio.noPatronymic = false;
                }
            }
            if (data.insurer === undefined) data.insurer = {};
            if (data.insurer.address === undefined)
                data.insurer.address = {search: null};

            this.term = Number.isInteger(data.term) ? data.term : this.term;
            this.dateStart = data.dateStart ? data.dateStart : "";
            // this.useTargetPersonal = data.useTargetPersonal === true;
            this.noDiscountForTransfer = data.noDiscountForTransfer
                ? data.noDiscountForTransfer
                : false;
            this.prevPolicyNumber = data.prevPolicyNumber
                ? data.prevPolicyNumber
                : "";
            this.privacyPolicyApproved = data.privacyPolicyApproved === true;
            this.usagePurpose =
                data.usagePurpose === "none" ? null : data.usagePurpose;
            this.useType = data.useType;
            this.dateOldPolis = data.dateOldPolis ? data.dateOldPolis : null;
            this.osagoCompanyName = data.osagoCompanyName
                ? data.osagoCompanyName
                : null;
            this.alertText = data.alertText ? data.alertText : null;
            this.alertColor = data.alertColor ? data.alertColor : null;
            this.isDraft = data.isDraft ? data.isDraft : null;
            this.tsChanged = data.tsChanged ? data.tsChanged : null;
            this.isAnyInternationalRight = data.isAnyInternationalRight ? data.isAnyInternationalRight : false;

            if (data.rsaInfo !== undefined) {
                this.rsaInfo = data.rsaInfo ? data.rsaInfo : null;
            }

            if (data.drivers === "unlimited") {
                this.unlimitedDrivers = true;
                this.drivers = data.drivers;
            } else {
                if (data.drivers) {
                    data.drivers.forEach((driver) => {
                        driver.address = {search: null};

                        if (driver.isInsurer || this.isSamePerson(driver, data.insurer)) {
                            driver.isInsurer = true;
                            driver.passport = data.insurer.passport
                                ? data.insurer.passport
                                : {};
                            driver.address = data.insurer.address ? data.insurer.address : {};
                        }

                        if (driver.isOwner || this.isSamePerson(driver, data.owner)) {
                            driver.isOwner = true;
                            driver.passport = data.owner.passport ? data.owner.passport : {};
                            driver.address = data.owner.address ? data.owner.address : {};
                        }

                        if (driver.fio.noPatronymic === undefined) {
                            driver.fio.noPatronymic = false;
                        }
                        // Если полис для е-гарант, то нужно очистить данные по старым правам
                        if (this.isEgarant) {
                            driver.license.oldSeriesNumber = "";
                            driver.license.old = false;
                        }

                        if (driver.license && driver.license.oldSeriesNumber) {
                            this.updateMaskOldSeriesNumber(
                                driver.license.oldSeriesNumber,
                                driver,
                            );
                        }

                        if (driver.license && driver.license.seriesNumber) {
                            this.updateMaskSeriesNumber(driver.license.seriesNumber, driver);
                        }

                        if (driver.license && driver.license.isInternationalDriverLicense) {
                            driver.passport.isInternationalDriverLicense = driver.license.isInternationalDriverLicense;
                        }

                        this.drivers.push(driver);
                    });
                }
            }

            this.insurer = Object.assign(this.insurer, data.insurer);
            this.owner = Object.assign(this.owner, data.owner);
            this.transport = Object.assign(this.transport, data.transport);
            // пока что обнуляем данные ДК
            this.transport.toDoc = this.toDocDefault;
            if (this.transport.carDoc.type === "srts") {
                // при указании документа СТС ввод госномера обязателен
                this.transport.noLicensePlate = false;
            }
            this.user = Object.assign(this.user, data.user);
            if (!data.user.email) {
                this.user.email = this.authUser.email ? this.authUser.email : '';
            }
            if (!data.user.phone) {
                this.user.phone = this.authUser.phone ? this.authUser.phone.replace(/\D/g, '') : '';
            }
        },

        prepareFormData() {
            let owner = _.cloneDeep(this.owner);
            let insurer = _.cloneDeep(this.insurer);

            if (!this.unlimitedDrivers) {
                this.drivers.forEach(function (driver) {
                    if (driver.isOwner) owner = _.cloneDeep(driver);
                    if (driver.isInsurer) insurer = _.cloneDeep(driver);
                });
            }

            if (
                (!this.driverIsInsurer && !this.driverIsOwner) ||
                this.unlimitedDrivers
            ) {
                insurer = _.cloneDeep(this.owner);
            }
            this.preparedFormData = {
                term: _.cloneDeep(this.term),
                dateStart: _.cloneDeep(this.dateStart),
                dateOldPolis: this.dateOldPolis,
                osagoCompanyName: this.osagoCompanyName,
                // useTargetPersonal: _.cloneDeep(this.useTargetPersonal),
                noDiscountForTransfer: this.noDiscountForTransfer,
                useType: this.useType,
                // выбранная цель использования
                usagePurpose: this.usagePurpose,
                privacyPolicyApproved: this.privacyPolicyApproved,
                prevPolicyNumber: _.cloneDeep(this.prevPolicyNumber),
                drivers: this.unlimitedDrivers
                    ? "unlimited"
                    : _.cloneDeep(this.drivers),
                owner: owner,
                insurer: insurer,
                transport: _.cloneDeep(this.transport),
                user: _.cloneDeep(this.user),
                isEgarant: this.isEgarant,
                preprocess: false,
                alertText: this.alertText,
                alertColor: this.alertColor,
                rsaInfo: this.rsaInfo,
                isDraft: this.isDraft,
                tsChanged: this.tsChanged,
                isAnyInternationalRight: this.isAnyInternationalRight,
            };
        },

        autoSaveOn(timeout) {
            let that = this;
            this.autoSaveInterval = setInterval(function () {
                that.prepareFormData();

                if (that.lastSavedFormData == null) {
                    that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                    return;
                }
                if (!_.isEqual(that.lastSavedFormData, that.preparedFormData)) {
                    if (that.b2b) {
                        that.save(that.preparedFormData);
                    } else {
                        that.update(that.preparedFormData);
                    }
                    that.lastSavedFormData = _.cloneDeep(that.preparedFormData);

                    if (!this.formIsChanged && this.isOrderDataLoaded) {
                        that.formIsChanged = true;
                    }
                }
            }, timeout);
        },

        autoSaveOff() {
            clearInterval(this.autoSaveInterval);
        },

        autoGetCodeOn() {
            if (!this.autoGetCodeInterval) {
                this.autoGetCodeInterval = setInterval(() => {
                    this.getTempNumberCode();
                }, 5000);
            }
        },

        autoGetCodeOff() {
            clearInterval(this.autoGetCodeInterval);
            this.autoGetCodeInterval = null;
        },

        changeInsuranceConditionsData(data) {
            this.dateStart = data.dateStart;
            this.term = data.term;
            // this.useTargetPersonal = data.useTargetPersonal;
            // выбранная цель использования
            this.usagePurpose = data.usagePurpose;

            this.useType = data.useType;
            this.dateOldPolis = data.dateOldPolis;
            this.osagoCompanyName = data.osagoCompanyName;
        },

        changeTextAndColor(data) {
            this.alertText = data.alertText;
            this.alertColor = data.alertColor;
        },

        save(formData) {
            return axios
                .post(
                    "/osago/new/" + (this.uuid ? this.uuid + "/save" : "save"),
                    formData,
                )
                .then((response) => {
                    this.syncPriorityProlongation(
                        response.data.priorityProlongation || null,
                    );

                    if (response.data.uuid) {
                        this.uuid = response.data.uuid;
                        window.history.pushState(null, null, "/osago/new/" + this.uuid);
                    } else if (response.data.rsaInfo) {
                        console.log(response.data.rsaInfo);
                        let info = response.data.rsaInfo;
                        this.prevPolicyNumber = info.policySerial;
                        if (info.policySerial !== null) {
                            if (info.companyName === null) {
                                this.hintText = "Предыдущий полис в РСА не найден";
                            } else {
                                this.hintText =
                                    "Найден " +
                                    (!this.hintTextActivity ? "не " : "") +
                                    "действующий полис компании " +
                                    info.companyName;
                            }
                        } else {
                            this.hintText = "Предыдущий полис ОСАГО не найден";
                            this.hintTextActivity = false;
                        }
                        if (this.prevPolicyNumber) {
                            this.prevPolicyNumber += " " + info.policyNumber;
                        } else {
                            this.prevPolicyNumber = null;
                        }
                        this.osagoCompanyName = info.companyName;
                        this.dateOldPolis = moment(info.endDate).format("YYYY-MM-DD");

                        this.prevPolicyLoading = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    //throw error;
                    if (error.response && error.response.data.message) {
                        // PNotify.alert('Ошибка. Проверьте правильность введенных данных.');
                        /*                            PNotify.alert(error.response.data.message);
                                                            if (error.response.data.errors) {
                                                                Object.keys(error.response.data.errors).forEach(function (item) {
                                                                    error.response.data.errors[item].forEach(v => PNotify.alert(v))
                                                                });
                                                            }*/
                    }
                    throw error;
                });
        },

        update(formData) {
            return axios
                .post(`/osago/calc/${this.uuid}/update`, formData)
                .then((response) => {
                    if (response.data.uuid) {
                        if (!this.b2b) {
                            this.$emit("updateFromStep3", this.preparedFormData);
                            this.savePreparedData();
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    throw error;
                });
        },

        validateAndSubmit() {
            this.$nextTick(function () {
                if (this.$refs.form.validate()) {
                    this.prepareFormData();
                    this.$nextTick(function () {
                        this.submit();
                    });
                } else {
                    this.$nextTick(function () {
                        PNotify.error("Проверьте правильность выделенных полей.");
                        this.goToFirstError();
                    });
                }
            });
        },

        validate() {
            if (this.$refs.form.validate()) {
                this.reachGoal("step4_click");
                this.prepareFormData();
                this.preview.show = true;

                this.$nextTick(() => {
                    const previewEl = document.querySelector(".preview-window");
                    if (previewEl) {
                        previewEl.style.height = `${window.innerHeight}px`;
                    }
                });

                this.reachGoal("calcFinish");
            } else {
                this.$nextTick(() => {
                    PNotify.error("Проверьте правильность выделенных полей.");
                    this.goToFirstError();
                });
            }
        },

        validateWithoutPreview() {
            if (this.$refs.form.validate()) {
                this.prepareFormData();
                return true;
            } else {
                this.$nextTick(function () {
                    PNotify.error("Проверьте правильность выделенных полей.");
                    this.goToFirstError();
                });
                return false;
            }
        },

        goToFirstError() {
            this.$vuetify.goTo(".error--text", {
                duration: 600,
                offset: 150,
                easing: "easeInCubic",
            });
        },

        goToCompaniesList() {
            this.$vuetify.goTo("#companiesList", {
                duration: 600,
                offset: 150,
                easing: "easeInCubic",
            });
        },

        goToProlongation() {
            window.location.replace("/osago/prolongation");
        },

        returnToEdit() {
            this.preview.show = false;
            this.reachGoal("calcDataFalse");
        },

        startWaitLoading() {
            this.waitLoading = true;
            this.remainingTime = 60;

            const interval = setInterval(() => {
                this.remainingTime -= 1;

                if (this.remainingTime <= 0) {
                    clearInterval(interval);
                    this.waitLoading = false;
                }
            }, 1000);
        },

        async submit() {
            this.formIsChanged = false;
            this.egarantLinks = [];
            this.wait = true;
            this.allowApproveMetrika = true;
            this.preparedFormData["preprocess"] = true;
            this.crossRequested = false;
            this.isDraft = false;

            if (!this.b2b) {
                this.setPreloading();
                this.$vuetify.goTo(".to-counting");
            }

            /*const crossPromise = this.fetchCrossData();*/

            try {
                const response = await axios.post(
                    "/osago/new/" + (this.uuid ? this.uuid + "/update" : "new"),
                    this.preparedFormData,
                );

                if (response.data.uuid) {
                    this.uuid = response.data.uuid;
                    if (this.b2b) {
                        window.history.pushState(null, null, "/osago/new/" + this.uuid);
                    }
                }

                /*this.autoSaveOff();*/
                this.companiesList = response.data.companiesList;
                this.syncPriorityProlongation(
                    response.data.priorityProlongation || null,
                );

                await this.waitForRsaResolutionBeforeCalculation();

                _.forEach(this.companiesList, function (company) {
                    Vue.set(company, "showCross", true);
                    Vue.set(company, "crosses", null);
                    Vue.set(company, "panel", ["0"]);
                });

                this.companiesList.map((company, index) =>
                    this.process(company, index),
                );

                if (this.b2b) {
                    this.policyPrecalc();
                }

                this.preview.show = false;

                if (this.b2b) {
                    const preloadingEl = document.querySelector(".preloading");

                    if (preloadingEl) {
                        preloadingEl.style.height = `${window.innerHeight}px`;
                    }

                    this.preloading = true;

                    setTimeout(() => {
                        this.$vuetify
                            .goTo(".preloading", {
                                duration: 500,
                                offset: 0,
                                easing: "easeInCubic",
                            })
                            .then(() => {
                                if (preloadingEl) {
                                    preloadingEl.style.position = "fixed";
                                    preloadingEl.style.height = "100%";
                                }
                            });
                    }, 100);

                    setTimeout(() => {
                        this.preloading = false;
                    }, 3 * 1000);
                }

                setTimeout(() => {
                    this.$vuetify.goTo("#companiesList", {
                        duration: 600,
                        offset: 150,
                        easing: "easeInCubic",
                    });
                }, 1000);

                this.reachGoal("calcDataTrue");
                this.startWaitLoading();
            } catch (error) {
                PNotify.error("Произошла ошибка, попробуйте расчитать ещё раз.");
                this.catchSubmitError(error);
            } finally {
                this.wait = false;
                this.goToCompaniesList();
            }

            /*try {
                      this.crossOffers = await crossPromise;
                      this.companiesList.forEach(company => {
                          Vue.set(company, 'crosses', this.crossOffers);
                      });
                  } catch (e) {
                      console.error('Ошибка загрузки кроссов:', e);
                  }*/

            // this.pollCrossStatus()
        },

        async fetchCrossData() {
            this.waitFetchCross = true;
            try {
                const response = await axios.get(`/cross/calc/${this.uuid}`);
                if (response.data.success === 200) {
                    const parsedData =
                        typeof response.data.data === "string"
                            ? JSON.parse(response.data.data)
                            : response.data.data;

                    if (parsedData.crosses && parsedData.crosses.length > 0) {
                        this.crossOffers = response.data.data;
                        this.companiesList.forEach((company) => {
                            company.crosses = this.crossOffers;
                        });
                    }
                } else {
                    return [];
                }
            } catch (error) {
                console.error("Ошибка при загрузке cross/calc:", error);
                return [];
            } finally {
                this.waitFetchCross = false;
            }
        },

        // TODO если будем использовать JOB
        // Метод для опроса статуса кросс-продукта
        // pollCrossStatus(attempts = 0) {
        //     if (attempts >= 5) {
        //         console.error('Превышено время ожидания');
        //         return;
        //     }
        //
        //     const checkStatus = () => {
        //         axios.get(`/cross/status/${this.uuid}`)
        //             .then(response => {
        //                 if (response.data.success === 200) {
        //                     console.log(response.data.data);
        //                 } else if (response.data.success === 202) {
        //                     setTimeout(() => this.pollCrossStatus(attempts + 1), 5000);
        //                 }
        //             })
        //             .catch(error => {
        //                 console.error('Ошибка проверки статуса:', error);
        //             });
        //     };
        //
        //     // Первая проверка
        //     checkStatus();
        // },

        async process(company, index, reProcess = false) {
            if (this.WAIT_PREV_POLICY_COMPANIES_LIST.includes(company.alias))
                await this.waitForPrevPolicy();

            this.processings++;
            axios
                .get(company.url)
                .then((response) => {
                    this.processings--;
                    const currentCompany = this.companiesList[index];

                    if (
                        response.data.company === undefined ||
                        response.data.company.payment === undefined
                    ) {
                        currentCompany.status = "error";
                        this.applyPriorityExclusionIfNeeded(currentCompany);
                    } else {
                        Object.assign(currentCompany, response.data.company);

                        this.syncPriorityProlongation(
                            response.data.priorityProlongation || null,
                        );

                        this.applyPriorityExclusionIfNeeded(currentCompany);

                        if (
                            !this.crossRequested &&
                            response.data.company.status !== "error"
                        ) {
                            this.crossRequested = true;
                            this.fetchCrossData();
                        }
                    }

                    /*if (this.KBM_COMPANIES_LIST.includes(company.alias)) this.setKBM();*/
                })
                .catch((error) => {
                    /*if (this.KBM_COMPANIES_LIST.includes(company.alias)) this.setKBM();*/

                    if (
                        company.alias == "astro-volga" &&
                        !reProcess &&
                        error.response.data.message.includes(
                            "Повторите запрос когда вычисление КБМ закончится",
                        )
                    ) {
                        setTimeout(() => {
                            this.process(company, index, !reProcess);
                        }, 15000);
                        return;
                    } else {
                        this.processings--;
                        company.status = "error";
                        if (error.response && error.response.data.message) {
                            company.error_text = error.response.data.message;
                            /*PNotify.error(company.name + ":\n" + error.response.data.message);*/
                        }

                        this.applyPriorityExclusionIfNeeded(company);
                    }
                });
            //Vue.set(this.companiesList, index, company);
        },

        waitForPrevPolicy() {
            return new Promise((resolve) => {
                const checkPrevPolicy = () => {
                    if (!this.prevPolicyLoading) {
                        resolve();
                    } else {
                        setTimeout(checkPrevPolicy, 10000);
                    }
                };
                checkPrevPolicy();
            });
        },

        policyPrecalc() {
            axios
                .get("/osago/new/" + this.uuid + "/precalc")
                .then((response) => {
                    if (response && response.data) {
                        const comp = response.data;
                        this.defaultCompany.period = comp.period;
                        this.defaultCompany.premium = comp.premium;
                        this.defaultCompany.commission = comp.commission;
                        this.defaultCompany.commissionRub = comp.commissionRub;
                        this.defaultCompany.kbm = comp.kbm;

                        this.precalc.premium = comp.premium;
                        Vue.set(
                            this.precalc,
                            "coefficients",
                            JSON.parse(comp.coefficients),
                        );
                    } else {
                        console.log(response);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.precalc.premium = null;
                    Vue.set(this.precalc, "coefficients", null);
                    this.defaultCompany.period =
                        this.defaultCompany.premium =
                            this.defaultCompany.commission =
                                this.defaultCompany.commissionRub =
                                    this.defaultCompany.kbm =
                                        null;
                });
        },

        clear() {
            this.$refs.form.reset();
        },

        egarantPrecalc() {
            let that = this;
            this.egarantLoading = true;
            axios
                .get("/egarant/precalc/" + this.uuid)
                .then((response) => {
                    if (response.data && response.data.status === "success") {
                        that.precalc.premium = response.data.premium;
                        Vue.set(
                            that.precalc,
                            "coefficients",
                            JSON.parse(response.data.coefficients),
                        );
                        that.egarantLink = _.clone(that.egarantLinkDefault);
                        if (response.data.message) {
                            PNotify.alert(response.data.message);
                        }
                    } else {
                        console.log(response);
                        PNotify.error("Ошибка при предрасчете");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    PNotify.error("Ошибка при предрасчете");
                })
                .finally(() => {
                    that.egarantLoading = false;
                });
        },

        egarantGet() {
            let that = this;
            if (!that.validateWithoutPreview()) {
                return;
            }
            that.reachGoal("calcDataTrue");
            this.egarantLoading = true;
            axios
                .get("/egarant/" + this.uuid)
                .then((response) => {
                    if (response.data) {
                        this.processEgarantResponse(that, response.data.link);
                        if (response.data.tempPhone) {
                            that.user.tempPhone = response.data.tempPhone;
                            that.user.phoneCode = null;
                            if (
                                response.data.link.status === "on" &&
                                that.user.useTempNumber
                            ) {
                                this.autoGetCodeOn();
                            }
                        }
                    } else {
                        PNotify.error("Не удалось рассчитать полис.");
                    }
                    that.egarantLoading = false;
                })
                .catch((error) => {
                    console.log(error.response ? error.response : error);
                    that.egarantLoading = false;
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        PNotify.error(error.response.data.message);
                    } else {
                        PNotify.error("Не удалось рассчитать полис.");
                    }
                });
        },

        processEgarantResponse(context, data) {
            this.egarantLink.alias = data.alias;
            this.egarantLink.name = data.name;
            this.egarantLink.draftId = data.draftId;
            this.egarantLink.link = data.link;
            this.egarantLink.errors = data.errors;
            this.egarantLink.status = data.status;
            this.egarantLink.kbms = data.drivers_kbms;
            this.egarantLink.created_at = data.created_at;

            // обработка истечения срока действия ссылки Е-Гарант
            this.setEgarantTimer(data);

            if (data.status === "on") {
                PNotify.success("Расчет прошел успешно.");
                this.orderStatus = "approved";
            }
            if (data.status === "off") {
                PNotify.error("Возникла ошибка при расчете полиса: " + data.errors);
                this.orderStatus = "new";
            }
        },

        getTempNumberCode() {
            axios
                .get("/sms/getCode/" + this.uuid)
                .then((response) => {
                    if (response.data) {
                        if (response.data.status === "ok") {
                            this.user.phoneCode = response.data.code;
                            this.autoGetCodeOff();
                        }
                    } else {
                        this.autoGetCodeOff();
                        console.log(response);
                        PNotify.error("Не удалось получить код.");
                    }
                })
                .catch((error) => {
                    this.autoGetCodeOff();
                    console.log(error);
                    PNotify.error("Не удалось получить код.");
                });
        },

        setEgarantTimer(link) {
            if (!link.created_at) {
                return;
            }
            const createdAt = moment(link.created_at);
            const activeTo = moment(createdAt)
                .add("59", "minutes")
                .add("59", "seconds");
            let duration = moment.duration(
                activeTo.diff(moment(link.now), "seconds") * 1000,
                "milliseconds",
            );
            let ms = duration.as("milliseconds");
            const startTimestamp = +moment();
            if (ms <= 0) {
                this.egarantLink.timed_out = true;
            } else {
                this.egarantLink.timed_out = false;
                if (!this.egarantLink.time_warning && duration.minutes() < 5) {
                    this.egarantLink.time_warning = true;
                }
                this.egarantLink.time_left = moment.utc(ms).format("mm:ss");
                const interval = 1000;
                let that = this;
                if (this.egarantLinkInterval) {
                    clearInterval(this.egarantLinkInterval);
                }
                this.egarantLinkInterval = setInterval(function () {
                    let tempDuration = moment.duration(
                        duration - (+moment() - startTimestamp),
                        "milliseconds",
                    );
                    ms = tempDuration.as("milliseconds");
                    if (ms <= 0) {
                        clearInterval(that.egarantLinkInterval);
                        that.egarantLink.timed_out = true;
                    } else {
                        that.egarantLink.timed_out = false;
                    }
                    if (!that.egarantLink.time_warning && tempDuration.minutes() < 5) {
                        that.egarantLink.time_warning = true;
                    }
                    that.egarantLink.time_left = moment.utc(ms).format("mm:ss");
                }, interval);
            }
        },

        submitEgarant() {
            this.formIsChanged = false;
            const that = this;
            axios
                .post(
                    "/osago/new/" + (this.uuid ? this.uuid + "/update" : "new"),
                    this.preparedFormData,
                )
                .then((response) => {
                    if (response.data.uuid) {
                        that.uuid = response.data.uuid;
                        if (this.b2b) {
                            window.history.pushState(null, null, "/osago/new/" + this.uuid);
                        }
                    }
                    that.preview.show = false;

                    if (this.b2b) {
                        $(".preloading").css("height", $(window).height());

                        setTimeout(function () {
                            that.$vuetify
                                .goTo(".preloading", {
                                    duration: 500,
                                    offset: 0,
                                    easing: "easeInCubic",
                                })
                                .then(() => {
                                    $(".preloading")
                                        .css("position", "fixed")
                                        .css("height", "100%");
                                });
                        }, 100);

                        setTimeout(function () {
                            that.preloading = false;
                        }, 5 * 1000);
                    }

                    that.egarantPrecalc();
                })
                .catch((error) => {
                    this.catchSubmitError(error);
                });
        },

        egarantCheckCalculation() {
            axios
                .get("/egarant/check-calc/" + this.uuid)
                .then((response) => {
                    if (response.data && response.data.egarantCalculating === false) {
                        this.egarantNeedToCheckCalculation = this.egarantLoading = false;
                        this.egarantCheckIntervalOff();
                        if (response.data.egarantLink) {
                            this.processEgarantResponse(this, response.data.egarantLink);
                        }
                    } else {
                        console.log(response);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        egarantCheckIntervalOn(timeout) {
            let that = this;
            this.egarantCheckInterval = setInterval(function () {
                that.egarantCheckCalculation();
            }, timeout);
        },

        egarantCheckIntervalOff() {
            clearInterval(this.egarantCheckInterval);
        },

        loadRsaPolicyData() {
            const hasVin = !!this.transport.vin;
            const vinReady = hasVin && this.transport.vin.length === 17;
            const hasBody = !!this.transport.bodyNumber;

            // Если VIN есть, но неполный — просто выходим и не трогаем лоадер
            if (hasVin && !vinReady) {
                return;
            }

            if (vinReady) {
                this.prevPolicyLoading = true;
                return this.rsaDataRequest(this.transport.vin, "vin");
            }

            if (hasBody) {
                this.prevPolicyLoading = true;
                return this.rsaDataRequest(this.transport.bodyNumber, "body");
            }
        },

        async getRSAStatus() {
            try {
                const result = await axios.get("/osago/new/" + this.uuid + "/rsa");
                if (result.data) {
                    this.hintTextActivity = result.data.active;
                    this.rsaStatusResolved = typeof result.data.active === "boolean";
                    this.lastSavedFormData = null;
                    return result.data.active;
                }
            } catch (error) {
                console.error(error);
            }
        },

        shouldWaitForRsaBeforeCalculation() {
            return !!this.uuid && (!!this.transport.vin || !!this.transport.bodyNumber);
        },

        async waitForRsaResolutionBeforeCalculation() {
            if (!this.shouldWaitForRsaBeforeCalculation()) {
                return;
            }

            const currentStatus = await this.getRSAStatus();
            if (typeof currentStatus === "boolean") {
                return;
            }

            if (!this.rsaInfoLoading) {
                await this.loadRsaPolicyData();
                const loadedStatus = await this.getRSAStatus();
                if (typeof loadedStatus === "boolean") {
                    return;
                }
            }

            for (let attempt = 0; attempt < 15; attempt += 1) {
                await new Promise((resolve) => setTimeout(resolve, 1000));
                const nextStatus = await this.getRSAStatus();

                if (typeof nextStatus === "boolean") {
                    return;
                }
            }
        },

        rsaDataRequest(number, type) {
            if (this.rsaInfoLoading === true) {
                return this.rsaInfoRequestPromise;
            }
            this.rsaInfoLoading = true;
            let param = "";
            switch (type) {
                case "vin":
                    param = "vin=" + number;
                    break;
                case "body":
                    param = "bodyNumber=" + number;
                    break;
                default:
                    PNotify.error("Невозможно получить данные предыдущего полиса.");
                    return;
            }
            let that = this;
            param += "&uuid=" + this.uuid;

            this.rsaInfoRequestPromise = axios
                .get("/info/rsa?" + param)
                .then(async (result) => {
                    let responseFromRsaRequest;

                    if (typeof result.data === "string") {
                        try {
                            responseFromRsaRequest = JSON.parse(result.data);
                        } catch (e) {
                            console.error("Ошибка парсинга JSON:", e);
                            return;
                        }
                    } else if (typeof result.data === "object" && result.data !== null) {
                        responseFromRsaRequest = result.data;
                    } else {
                        console.error("Неожиданный формат ответа RSA:", result.data);
                        return;
                    }

                    if (
                        responseFromRsaRequest.response &&
                        responseFromRsaRequest.status === "ok"
                    ) {
                        const info = responseFromRsaRequest.response;

                        this.rsaInfo = info;
                        this.prepareFormData();
                        await this.save(this.preparedFormData);
                        let status = await this.getRSAStatus();
                        that.prevPolicyNumber = info.policySerial;
                        if (info.policySerial !== null) {
                            if (info.companyName === null) {
                                that.hintText = "Предыдущий полис в РСА не найден";
                            } else {
                                that.hintText =
                                    "Найден " +
                                    (!this.hintTextActivity ? "не " : "") +
                                    "действующий полис компании " +
                                    info.companyName;
                            }
                        } else {
                            that.hintText = "Предыдущий полис ОСАГО не найден";
                            this.hintTextActivity = false;
                        }
                        if (that.prevPolicyNumber) {
                            that.prevPolicyNumber += " " + info.policyNumber;
                        } else {
                            that.prevPolicyNumber = null;
                        }
                        that.osagoCompanyName = info.companyName;
                        that.dateOldPolis = moment(info.endDate).format("YYYY-MM-DD");

                        that.prevPolicyLoading = false;
                    } else {
                        that.hintText = "Предыдущий полис ОСАГО не найден";
                        that.hintTextActivity = false;
                        that.prevPolicyLoading = false;
                        console.log("RSA info response:", result);
                    }
                })
                .catch((error) => {
                    that.prevPolicyLoading = false;
                    console.log(error);
                })
                .finally(async () => {
                    if (this.hintText) {
                        await this.getRSAStatus();

                        if (that.osagoCompanyName === null) {
                            that.hintText = "Предыдущий полис в РСА не найден";
                        } else {
                            that.hintText =
                                "Найден " +
                                (!this.hintTextActivity ? "не " : "") +
                                "действующий полис компании " +
                                that.osagoCompanyName;
                        }
                    }
                    this.rsaInfoLoading = false;
                    that.prepareFormData();
                    await this.save(that.preparedFormData);
                    this.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                    this.rsaInfoRequestPromise = null;
                });

            return this.rsaInfoRequestPromise;
        },

        catchSubmitError(error) {
            console.log(error);
            this.preview.show = false;
            if (error.response.data.message) {
                let errorTexts = "";

                if (error.response.data.errors) {
                    Object.keys(error.response.data.errors).forEach(function (item) {
                        error.response.data.errors[item].forEach(
                            (v) => (errorTexts += " " + v),
                        );
                    });
                }
                PNotify.alert(error.response.data.message + errorTexts);
            }
            throw error;
        },

        getFirstLicenseYears(minDate, maxDate) {
            const minYear = minDate ? +minDate.split("-")[0] : 1920;
            const maxYear = maxDate ? +maxDate.split("-")[0] : 2099;
            let years = [];
            for (let i = maxYear; i >= minYear; i--) {
                years[years.length] = i;
            }
            return years;
        },

        setKBM() {
            if (this.orderStatus !== "success") {
                let that = this;
                _.forEach(that.drivers, function (driver) {
                    if (
                        driver.fio &&
                        driver.fio.surname &&
                        driver.fio.patronymic &&
                        driver.birthday &&
                        driver.license &&
                        driver.license.seriesNumber &&
                        driver.license.date
                    ) {
                        let kbmReq;
                        if (that.isDraft) {
                            kbmReq = {driver: driver, force: true};
                        } else {
                            kbmReq = {driver: driver};
                        }
                        axios
                            .post("/driver/kbm", kbmReq)
                            .then((response) => {
                                if (response.data) {
                                    let kbmValue = response.data.value;
                                    let kbmText = response.data.text;

                                    /*driver.kbmText = 'КБМ — ' + kbmValue  + ' ' + kbmText;*/
                                    driver.kbmText = "КБМ — " + kbmValue;
                                }
                            })
                            .catch((error) => {
                                driver.kbmText = null;
                            });
                    }
                });
            }
        },

        updateMaskSeriesNumber(seriesNumber, driver) {
            const firstChar = seriesNumber.charAt(0);
            if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) {
                driver.maskSeriesNumber = "RR ######";
            } else if (/^\d$/.test(firstChar)) {
                driver.maskSeriesNumber = "##SS ######";
            } else {
                driver.maskSeriesNumber = "S";
            }
        },

        updateMaskOldSeriesNumber(seriesNumber, driver) {
            const firstChar = seriesNumber.charAt(0);
            if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) {
                driver.maskOldSeriesNumber = "RR ######";
            } else if (/^\d$/.test(firstChar)) {
                driver.maskOldSeriesNumber = "##SS ######";
            } else {
                driver.maskOldSeriesNumber = "S";
            }
        },

        handlePasteSeriesNumber(event, driver) {
            let pastedText = (event.clipboardData || window.clipboardData)
                .getData("text")
                .trim();
            if (!pastedText) return;

            pastedText = pastedText.replace(/\s+/g, "");

            const firstChar = pastedText.charAt(0);

            if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) {
                driver.maskSeriesNumber = "RR ######";
            } else if (/^\d$/.test(firstChar)) {
                driver.maskSeriesNumber = "##SS ######";
            } else {
                driver.maskSeriesNumber = "S";
            }

            this.$nextTick(() => {
                if (/^\d{2}[A-Za-zА-Яа-яЁё\d]{2}\d{6}$/.test(pastedText)) {
                    driver.license.seriesNumber = `${pastedText.slice(0, 4)} ${pastedText.slice(4)}`;
                } else if (/^\d{10}$/.test(pastedText)) {
                    driver.license.seriesNumber = `${pastedText.slice(0, 4)} ${pastedText.slice(4)}`;
                } else {
                    driver.license.seriesNumber = pastedText;
                }
            });

            event.preventDefault();
        },

        handlePasteOldSeriesNumber(event, driver) {
            let pastedText = (event.clipboardData || window.clipboardData)
                .getData("text")
                .trim();
            if (!pastedText) return;

            pastedText = pastedText.replace(/\s+/g, "");

            const firstChar = pastedText.charAt(0);

            if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) {
                driver.maskOldSeriesNumber = "RR ######";
            } else if (/^\d$/.test(firstChar)) {
                driver.maskOldSeriesNumber = "##SS ######";
            } else {
                driver.maskOldSeriesNumber = "S";
            }

            this.$nextTick(() => {
                if (/^\d{2}[A-Za-zА-Яа-яЁё\d]{2}\d{6}$/.test(pastedText)) {
                    driver.license.oldSeriesNumber = `${pastedText.slice(0, 4)} ${pastedText.slice(4)}`;
                } else if (/^\d{10}$/.test(pastedText)) {
                    driver.license.oldSeriesNumber = `${pastedText.slice(0, 4)} ${pastedText.slice(4)}`;
                } else {
                    driver.license.oldSeriesNumber = pastedText;
                }
            });

            event.preventDefault();
        },

        handleDriversKbms(driversKbms) {
            this.kbms = driversKbms;
        },

        resolveExcludedCompanies() {
            this.companiesList.forEach((company) => {
                if (this.excludedProlongationAliases.includes(company.alias)) {
                    this.applyExclusionResolution(company);
                }
            });
        },
        applyPriorityExclusionIfNeeded(company) {
            if (this.excludedProlongationAliases.includes(company.alias)) {
                this.applyExclusionResolution(company);
            }
        },
        startPriorityProlongationSession(priorityProlongation) {
            this.syncPriorityProlongation(priorityProlongation);
        },

        syncPriorityProlongation(priorityProlongation) {
            if (!priorityProlongation) {
                this.restorePriorityBlockedCompanies();
                this.priorityProlongationAlias = null;
                this.priorityProlongationSegmentType = null;
                this.excludedProlongationAliasesByType = {};
                this.excludedProlongationAliases = [];
                this.priorityProlongationSessionActive = false;
                this.priorityProlongationResolved = false;
                this.priorityProlongationApproved = false;
                return;
            }

            const nextAlias = priorityProlongation.priority_alias || null;
            const nextSegmentType =
                priorityProlongation.effective_segment_type || null;
            const nextAliasesByType =
                priorityProlongation.excluded_aliases_by_type || {};
            const nextHiddenAliases = priorityProlongation.hidden_aliases || [];
            const nextState = priorityProlongation.state || null;
            const nextApproved = !!priorityProlongation.approved;
            const nextSelectedAliases = nextSegmentType
                ? (nextAliasesByType[nextSegmentType] || [])
                : [];
            const nextExcludedAliases = [
                ...new Set(
                    (nextApproved ? nextHiddenAliases : nextSelectedAliases).filter(
                        (alias) => alias && alias !== nextAlias,
                    ),
                ),
            ];
            const currentAliasesByType = this.excludedProlongationAliasesByType || {};

            const isSamePriorityConfig =
                this.priorityProlongationAlias === nextAlias &&
                this.priorityProlongationSegmentType === nextSegmentType &&
                _.isEqual(currentAliasesByType, nextAliasesByType) &&
                _.isEqual(this.excludedProlongationAliases, nextExcludedAliases) &&
                this.priorityProlongationApproved === nextApproved &&
                this.priorityProlongationResolved === (nextState !== "pending");

            if (isSamePriorityConfig) {
                return;
            }

            this.restorePriorityBlockedCompanies();

            this.priorityProlongationAlias = nextAlias;
            this.priorityProlongationSegmentType = nextSegmentType;
            this.excludedProlongationAliasesByType = nextAliasesByType;

            this.excludedProlongationAliases = nextExcludedAliases;
            this.priorityProlongationSessionActive = nextState === "pending";
            this.priorityProlongationResolved = nextState !== "pending";
            this.priorityProlongationApproved = nextApproved;

            this.resolveExcludedCompanies();
        },

        restorePriorityBlockedCompanies() {
            this.companiesList.forEach((company) => {
                if (!company._priorityBlocked) {
                    return;
                }

                company.status = company._savedStatus;
                company.payment = company._savedPayment;
                company.error_text = company._savedErrorText;
                this.$set(company, "_priorityBlocked", false);
            });
        },

        applyExclusionResolution(company) {
            if (this.priorityProlongationApproved) {
                if (company._priorityBlocked && company._savedStatus === "error") {
                    company.status = company._savedStatus;
                    company.payment = company._savedPayment;
                    company.error_text = company._savedErrorText;
                    this.$set(company, "_priorityBlocked", false);
                    return;
                }

                company.status = "error";
                company.error_text = "Предложение не поступило";
                company.payment = null;

                if (company._priorityBlocked) {
                    this.$set(company, "_priorityBlocked", false);
                }
            } else {
                this.$set(company, "_savedStatus", company.status);
                this.$set(company, "_savedPayment", company.payment);
                this.$set(company, "_savedErrorText", company.error_text || null);
                this.$set(company, "_priorityBlocked", true);

                company.status = "waiting";
                company.payment = null;
                company.error_text = null;
            }
        },

        formatDate(datetime) {
            return datetime.split(" ")[0];
        },

        async fetchCountries() {
            this.countriesLoading = true;

            try {
                const response = await axios.get('/transit/get-countries');
                this.countriesArray = Object.values(response.data)
                    .map(country => ({
                        ...country,
                        value: country.value.toString(),
                    }))
                    .sort((a, b) => a.text.localeCompare(b.text, 'ru'));
            } catch (error) {
                console.error('fetchCountries: ', error);
            } finally {
                this.countriesLoading = false;
            }
        },

        changeInternationalCountryName(driver) {
            const country = this.countriesArray.find((country) => country.value === driver.license.internationalCountryCode);
            driver.license.internationalCountryName = country.text;
        },

        removeSymbols: function (val) {
            if (!val) return '';
            const textRegex = /[^0-9A-Za-zА-ЯЁа-яё\- ./]/g;
            val = val
                .toString()
                .replace(/[ ]+/g, ' ')      // несколько пробелов в один
                .replace(/[-]+/g, '-')      // несколько тире в одно
                .replace(/[/.]+/g, m => m[0]) // несколько подряд точек или слэшей в один символ
                .replace(/^[ \-/.]/g, '')   // убрать пробел, тире, точку или слэш в начале строки
                .replace(/ [-/.]/g, match => match.trim()) // убрать пробел перед тире, точкой или слэшем
                .replace(/[-/.] /g, match => match.trim()) // убрать пробел после тире, точки или слэша
                .replace(textRegex, '');
            return val;
        },

        showInternationalHint() {
            const driver = window.driver.js.driver;

            const driverObj = driver({
                popoverClass: 'driverjs-theme',
                showButtons: ['close'],
            });

            driverObj.highlight({
                element: "#international-driver-license",
                popoverClass: 'driverjs-theme',
                showButtons: ['close'],
                popover: {
                    title: "Обновление",
                    description: "Появилась возможность указать иностранное водительское удостоверение"
                }
            });
        },
    }
}
</script>

<style scoped>
a.policy {
    color: #00ba57;
}

a.underline {
    text-decoration: underline;
}

.above-button {
    display: block;
    padding: 0 22px 10px;
}

.text-center {
    text-align: center;
}

.policy-wrapper {
    text-align: left;
    display: table-cell;
    vertical-align: middle;
}

.driverControls a {
    color: #000000;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 100px;
    background-color: #00ba57 !important;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.activePolice {
    color: #00ba57;
}

.notActivePolice {
    color: red;
}

.submit-button >>> .v-btn__content {
    white-space: normal;
    padding: 0 50px;
    line-height: 1.1;
}

.egarant-button {
    font-weight: 600 !important;
    font-size: 18px !important;
    line-height: 1.55 !important;
    height: 70px;
    width: 100%;
}

.egarant-button >>> .v-btn__content {
    padding: 0 !important;
}

.egarant-button >>> .v-btn__content {
    height: 100% !important;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
    line-height: 1;
    font-weight: 700;
    color: #000000;
}

@media (max-width: 960px) {
    /deep/ h1 {
        font-size: 54px;
    }
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

.preloading {
    position: relative;
    z-index: 999;
    height: 100%;
    width: 100%;
    max-width: 100%;
    overflow: visible;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    background: white;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.preloader-circle {
    background: #00ba57;
    width: 100px;
    height: 100px;
    margin: auto;
    border-radius: 100%;
    -webkit-animation: grow 1s infinite;
}

@-webkit-keyframes grow {
    0% {
        -webkit-transform: scale(0.7);
    }

    50% {
        -webkit-transform: scale(0.9);
    }

    100% {
        -webkit-transform: scale(0.7);
    }
}

/deep/ input[aria-label="Пол"] {
    padding: 0;
}

/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}

.result {
    padding: 36px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    transition: all 1s;
}

.result:last-child {
    border-bottom-width: 0;
}

.logo {
    max-width: 100%;
    width: 200px;
}

.logo-sm {
    max-width: 200px;
    width: 100%;
}

.prev-policy-label {
    display: inline-block;
    font-size: 14px;
    margin-top: 4px;
}

.kbm-text {
    font-size: 18px;
    white-space: pre-wrap;
}

.data-param {
    font-size: 24px;
    font-weight: bold;
    display: block;
    padding-top: 10px;
    text-align: center;
}

.preloading {
    position: fixed;
}

.warning-color {
    color: red;
}

.header-part h2 {
    font-size: 65px;
    line-height: 1;
    padding-bottom: 15px;
}

.header-part-title {
    padding-bottom: 40px;
}

.create-new-calc {
    padding-bottom: 20px;
}

.international-field {
    min-height: 50px;
}

.driver-kbm-text {
    font-weight: 600;
    font-size: 18px;
}

@media screen and (max-width: 960px) {
    .header-part h2 {
        font-size: 30px;
        padding-bottom: 20px;
    }

    .header-part-title {
        padding-bottom: 12px;
    }
}
</style>

<style>
@media (max-width: 600px) {
    .long-form-preloader .preloader-carousel-slider .main-carousel-slider-text {
        padding-top: 15px;
    }

    .long-form-preloader .preloader-carousel-slider .main-carousel-slider-icons {
        height: 60px;
    }

    .long-form-preloader
    .preloader-carousel-slider
    .main-carousel-slider-icons
    img {
        max-height: 60px;
    }

    .long-form-preloader .v-btn--icon.v-btn--small {
        width: 20px;
    }

    .long-form-preloader .preloader-carousel-slider .main-carousel-slider-text {
        font-size: 14px;
        line-height: 19px;
    }

    .long-form-preloader .preloader-carousel-slider .v-carousel__controls {
        padding: 15px;
    }
}

.driver-popover.driverjs-theme {
    background-color: #00ba57;
}

.driver-popover.driverjs-theme .driver-popover-title {
    font-size: 20px;
}

.driver-popover.driverjs-theme .driver-popover-title,
.driver-popover.driverjs-theme .driver-popover-description,
.driver-popover.driverjs-theme .driver-popover-progress-text {
    font-family: "SFUIDisplay", "Arial", "sans-serif";
    color: #ffffff;
}

.driver-popover.driverjs-theme button {
    flex: 1;
    text-align: center;
    background-color: transparent;
    color: #ffffff;
    text-shadow: none;
    font-size: 14px;
    padding: 5px 8px;
    border-radius: 6px;
}

.driver-popover.driverjs-theme button:hover {
    background-color: #000;
    color: #ffffff;
}

.driver-popover.driverjs-theme .driver-popover-navigation-btns {
    justify-content: space-between;
    gap: 3px;
}

.driver-popover.driverjs-theme .driver-popover-close-btn {
    color: #9b9b9b;
}

.driver-popover.driverjs-theme .driver-popover-close-btn:hover {
    color: #000;
}

.driver-popover.driverjs-theme
.driver-popover-arrow-side-left.driver-popover-arrow {
    border-left-color: #00ba57;
}

.driver-popover.driverjs-theme
.driver-popover-arrow-side-right.driver-popover-arrow {
    border-right-color: #00ba57;
}

.driver-popover.driverjs-theme
.driver-popover-arrow-side-top.driver-popover-arrow {
    border-top-color: #00ba57;
}

.driver-popover.driverjs-theme
.driver-popover-arrow-side-bottom.driver-popover-arrow {
    border-bottom-color: #00ba57;
}
</style>

<style scoped lang="scss">
@keyframes fadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
}

.breadcrumb-new {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 36px;
    font-size: 16px;
    color: #6b7a72;
    @media (max-width: 420px) {
        font-size: 14px;
    }
}

.breadcrumb-new a {
    color: #00BA57;
    text-decoration: none;
    font-weight: 500;
    transition: opacity .2s;
}

.breadcrumb-new a:hover { opacity: .7; }

.breadcrumb-new span { color: #c8d4cc; }

.breadcrumb-new { animation: fadeUp .4s ease both; }

.top-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
}

.page-title {
    span {
        color: #00BA57;
    }

    animation: fadeUp .6s ease both;
}

.osago-form-wrapper {
    @media (max-width: 960px) {
        padding: 10px;
    }
}

.policy-list-table {
    animation: fadeUp 1.2s ease both;
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e9eceb;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    margin-bottom: 20px;

    .flex {
        padding: 10px;
    }

    @media (max-width: 960px) {
        padding: 20px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/OsagoLongForm.vue